import type { FeatureConfig } from '@skynet/feature-config';
import { ClusterOutlined } from '@ant-design/icons';

import { SERVERS_ROUTE_PATH, SERVERS_URL } from './routes';

/**
 * Feature manifest for the admin Servers page. The dashboard shell reads this
 * single source of truth instead of hardcoding the route, navigation entry,
 * header label and Cerbos action across its routing, navigation, header and
 * access-control modules.
 *
 * `route.load` is a dynamic-import thunk, so importing this config for its
 * nav/header metadata never pulls the page implementation into the main bundle.
 *
 * `section`, `nav.key` and `cerbosAction` stay literal: they are the identifier
 * the Cerbos policy is written against (`read:admin:servers`), and renaming any
 * of them hides the nav item until the policy is renamed too.
 */
export const serversConfig = {
  domain: 'Admin',
  section: 'servers',
  route: {
    path: SERVERS_ROUTE_PATH,
    load: async () => ({ default: (await import('./ServersPage')).ServersPage }),
  },
  nav: {
    key: 'admin.servers',
    label: 'Servers',
    icon: <ClusterOutlined />,
    url: SERVERS_URL,
  },
  header: { label: 'Servers' },
  cerbosAction: 'read:admin:servers',
  needsEntityId: false,
} as const satisfies FeatureConfig;
